import type { SxProps } from "@mui/material/styles";
import type { muiTheme } from "@polifonia/theme";
import { theme } from "@polifonia/theme";

export const sharedStyles = {
  formSection: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  label: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  required: {
    color: theme.colors.staticFgNegative,
  },
  charCount: {
    color: theme.colors.neutral050,
    textAlign: "right",
  },
  charCountWithPadding: {
    color: theme.colors.neutral050,
    textAlign: "right",
    position: "absolute",
    bottom: "8px",
    right: "8px",
  },
  keyInputWrapper: {
    display: "flex",
    alignItems: "stretch",
    gap: 0,
  },
  keyPrefix: {
    display: "flex",
    alignItems: "center",
    padding: "0 12px",
    backgroundColor: theme.colors.staticBgPlain,
    border: `1px solid ${theme.colors.neutral030}`,
    borderRight: "none",
    borderRadius: "4px 0 0 4px",
    fontSize: "14px",
    color: theme.colors.staticFgNote,
    boxSizing: "border-box",
  },
  keyInput: {
    flex: 1,
    "& .MuiOutlinedInput-root": {
      borderRadius: "0 4px 4px 0",
    },
  },
  descriptionInput: {
    "& .MuiOutlinedInput-root": {
      position: "relative",
    },
  },
} satisfies Record<string, SxProps<typeof muiTheme>>;
